/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState } from 'react';
import { Button, Input } from '@nextui-org/react';
import { IconSearch } from '@tabler/icons-react';
import { classNames } from '../../../utils';
import { IconGroups, IconSubject } from '../../../assets/icons';
import Groups from './groups/groups';
import Subjects from './subjects/subjects';

const TYPE = {
  GROUPS: 1,
  SUBJECTS: 2,
}

const Grouping = () => {
  const { filters, filterBy } = useFecthFilters();

  return (
    <div>
      <Filters
        filterBy={filterBy}
      />

      {filters.type === TYPE.GROUPS
        ? <Groups filters={filters} />
        : <Subjects filters={filters} />

      }
    </div>
  );
}

const Filters = ({ canResetFilter, filterBy, resetFilter }) => {
  const initialFilter = {
    search: '',
    type: TYPE.GROUPS,
  };
  const [form, setForm] = useState(initialFilter);

  const onChange = (value, target) => {
    setForm(s => ({ ...s, [target]: value }));
    filterBy(value, target);
  }

  return (
    <section className="mb-4 grid sm:flex grid-cols-2 lg:flex-row items-end gap-4">
      <Input
        classNames={{
          base: 'w-full sm:max-w-[15rem]',
          inputWrapper: 'border-1 h-10',
        }}
        label="Buscar"
        labelPlacement="outside"
        placeholder="Nombre"
        startContent={<IconSearch />}
        variant="bordered"
        radius="sm"
        value={form.search}
        onValueChange={v => onChange(v, 'search')}
      />
      <Button
        className={classNames(
          'max-w-[10rem]',
          form.type === TYPE.GROUPS
            ? 'bg-green border-green text-white'
            : 'bg-white',
        )}
        variant="bordered"
        radius="sm"
        onClick={() => onChange(TYPE.GROUPS, 'type')}
        startContent={
          <img
            src={IconGroups}
            className={classNames('w-6 h-6', form.type === TYPE.GROUPS ? 'invert brightness-0' : '')}
            alt=""
          />
        }
      >
        Agrupamientos
      </Button>
      <Button
        className={classNames(
          'max-w-[10rem]',
          form.type === TYPE.SUBJECTS
            ? 'bg-green border-green text-white'
            : 'bg-white',
        )}
        variant="bordered"
        radius="sm"
        onClick={() => onChange(TYPE.SUBJECTS, 'type')}
        startContent={
          <img
            src={IconSubject}
            className={classNames('w-6 h-6', form.type === TYPE.SUBJECTS ? 'invert brightness-0' : '')}
            alt=""
          />
        }
      >
        <div className="flex flex-col items-start leading-4">
          Materias
        </div>
      </Button>

      {canResetFilter && (
        <Button
          variant="light"
          className="text-primaryDark"
          onClick={() => {
            setForm(initialFilter);
            resetFilter();
          }}
        >
          Limpiar filtros
        </Button>
      )}
    </section>
  )
}



const useFecthFilters = () => {
  const initialFilters = {
    search: '',
    since: null,
    until: null,
    type: TYPE.GROUPS,
  };

  const [filters, setFilters] = useState(initialFilters);

  const debounceTime = 500;
  const debounce = useRef();

  const filterBy = (value, target) => {
    if (debounce.current) clearTimeout(debounce.current);
    debounce.current = setTimeout(() => {
      setFilters({ ...filters, page: 1, [target]: value });
    }, debounceTime);
  }


  return {
    filters,
    filterBy,
  }
}

export default Grouping;
